import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotWorks from "./components/HotWorks";
import Categories from "./components/Categories";
import Gallery from "./components/Gallery";
import Updates from "./components/Updates";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "在线浏览是否需要注册账号？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "目前站内所有画集、图包与高清原图均支持免费在线浏览，无需注册即可欣赏。若后续开放收藏与下载记录功能，将另行说明账号体系安排。",
        },
      },
      {
        "@type": "Question",
        name: "高清原图与原图集有什么区别？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "高清原图指单张的大尺寸清晰图片，适合查看细节与收藏参考；原图集则是成册的画集，把同一作品的多张页面整合在一起，方便连贯阅读和批量浏览。",
        },
      },
    ],
  };

  const webSiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "同人本子官网",
    description:
      "同人本子官网提供高清原图与扫描画集在线浏览，涵盖热门作品同人插画与成套图包，支持在线预览与批量下载。",
    inLanguage: "zh-CN",
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">
        {JSON.stringify(faqJsonLd)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webSiteJsonLd)}
      </script>

      <Navbar />
      <main>
        <Hero />
        <HotWorks />
        <Categories />
        <Gallery />
        <Updates />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}